import { useMutation } from '@apollo/client';
import type { DeleteDocumentMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteDocumentDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteDocumentTRPC } from './useDeleteDocumentTRPC';

export const useDeleteDocument = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [deleteDocumentGraphQL, graphqlState] = useMutation(
    DeleteDocumentDocument,
    {
      update: (cache) => {
        evictField(cache, 'document');
      },
    }
  );

  const trpcMutation = useDeleteDocumentTRPC();

  const deleteDocument = async (
    id: string
  ): Promise<DeleteDocumentMutation> => {
    if (trpcEnabled) {
      return trpcMutation.deleteDocument(id);
    }

    const result = await deleteDocumentGraphQL({
      variables: { id },
    });
    if (!result.data) {
      throw new Error('Failed to delete document');
    }

    return result.data;
  };

  if (trpcEnabled) {
    return {
      deleteDocument,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    deleteDocument,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
